import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { housingApi } from './HousingApi';
import { housingActions } from './HousingSlice';
import { HousingListItem, HousingListResponse, ProvinceListRequest, SearchHousingRequest } from '../models/HousingList';
import { ListResponse } from 'setup/axios/HttpResponse';
import { HTTP_RESPONSE_STATUS } from 'setup/constants/Http';
import { ToastDefaultConfig } from 'setup/toast/ToastConfig';

function* fetchHousingList(action: PayloadAction<SearchHousingRequest>): Generator<any, void, any> {
  try {
    const response: ListResponse<HousingListItem> = yield call(housingApi.searchHousing, action.payload);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      const transformedResponse: HousingListResponse = {
        data: response.data.rows || [],
        total: response.data.pagination.totalRows || 0,
      };
      yield put(housingActions.fetchHousingListSuccess(transformedResponse));
    } else {
      toast.error(response.message || 'Failed to fetch busy time list', ToastDefaultConfig());
      yield put(housingActions.fetchHousingListFailed(response.message || 'Failed to fetch busy time list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch busy time list', ToastDefaultConfig());
    yield put(housingActions.fetchHousingListFailed(error.message || 'Failed to fetch busy time list'));
  }
}

function* fetchProvineList(action: PayloadAction<ProvinceListRequest>): Generator<any, void, any> {
  try {
    const response: ListResponse<any> = yield call(housingApi.getListProvince, action.payload);
    console.log("response", response);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      const transformedResponse = response.data.rows || [];
      yield put(housingActions.fetchProvineListSuccess(transformedResponse));
    } else {
      toast.error(response.message || 'Failed to fetch busy time list', ToastDefaultConfig());
      yield put(housingActions.fetchProvineListFailed(response.message || 'Failed to fetch busy time list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch busy time list', ToastDefaultConfig());
    yield put(housingActions.fetchProvineListFailed(error.message || 'Failed to fetch busy time list'));
  }
}

export function* housingSaga() {
  yield takeLatest(housingActions.fetchHousingListStart.type, fetchHousingList);
  yield takeLatest(housingActions.fetchProvineListStart.type, fetchProvineList);
}

export default housingSaga;

